import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import { update, list, store } from "../../actions";

export default () => {
  const moduleName = `settings`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const [metaDescription, setMetaDescription] = useState(``);
  const [metaKeywords, setMetaKeywords] = useState(``);
  const [metaTitle, setMetaTitle] = useState(``);
  const [topBarLink, setTopBarLink] = useState(``);
  const [image, setImage] = useState(``);
  const [imageMobile, setImageMobile] = useState(``);
  const [topBarState, setTopBarState] = useState(``);

  const handleClick = () => {
    dispatch(store(moduleName));
  };

  useEffect(() => {
    if (appReducer.settings_list != undefined) {
      let row = appReducer.settings_list.data[0];
      if (row) {
        setMetaKeywords(row.meta_keywords)
        setMetaDescription(row.meta_description)
        setMetaTitle(row.meta_title)
        setTopBarLink(row.top_bar_link)
        setImage(row.top_bar_image_full);
        setImageMobile(row.top_bar_image_mobile_full);
        setTopBarState({
          value: row.top_bar_state,
          label: row.top_bar_state == `active` ? `فعال` : `غیرفعال`,
        });
      }
    }
  }, [appReducer.settings_list]);

  useEffect(() => {
    dispatch(list(moduleName));
  }, []);

  const handleChangeState = (value) => setTopBarState(value);

  return (
    <Template.Form>

      <Template.Seo
        keywords={metaKeywords}
        description={metaDescription}
        title={metaTitle}
      />

      <Template.Input value={topBarLink} label="لینک تاپ‌بار" name="top_bar_link" type="text" />

      <Template.SingleSelect
        withLabel
        required
        placeholder="وضعیت تاپ‌بار"
        onChange={handleChangeState}
        name="top_bar_state"
        value={topBarState}
        options={[
          {
            value: "active",
            label: "فعال",
          },
          {
            value: "deactive",
            label: "غیرفعال",
          },
        ]}
      />

      <Template.FileInput
        deleteUrl="settings/destroy_image"
        className="image"
        value={image && [image]}
        name="top_bar_image"
        label="تصویر تاپ‌بار"
      />


      <Template.FileInput
        deleteUrl="settings/destroy_image_mobile"
        className="image"
        value={imageMobile && [imageMobile]}
        name="top_bar_image_mobile"
        label="تصویر تاپ‌بار حالت موبایل"
      />

      <Template.Button label="ذخیره" onClick={handleClick} />
      
    </Template.Form>
  );
};
